import type { NewsItem } from "@/types";

export const newsCategories: string[] = ["全部", "赛事新闻", "选手动态", "战报速递", "专题报道", "转会市场"];

export const news: NewsItem[] = [
  {
    id: "nw-2001",
    title: "湖人险胜凯尔特人，内线优势成为取胜关键",
    excerpt:
      "在今日结束的一场 NBA 焦点战中，湖人凭借末节稳定的内线发挥，以微弱优势战胜凯尔特人，取得两连胜。",
    content: [
      "在今日进行的一场 NBA 常规赛焦点之战中，洛杉矶湖人坐镇主场迎战波士顿凯尔特人。两支球队本赛季状态都相当出色，本场比赛从开场就充满火药味。",
      "上半场双方比分交替领先，湖人依靠内线高度在篮板球上占得先机，而凯尔特人则通过外线三分维持火力输出。半场结束时，两队分差始终没有超过 5 分。",
      "易边再战，湖人加强了对对方外线核心的包夹，迫使对手多次出现失误。第三节末段，湖人打出一波 10:2 的攻击波，将领先优势扩大到两位数。",
      "末节决战，凯尔特人一度将分差缩小到 3 分，但湖人在关键回合中把握住了罚球机会，最终守住胜果。赛后主教练表示，球队在防守端的专注度是本场取胜的最大原因。",
    ],
    category: "战报速递",
    author: "51每日大赛赛事组",
    date: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=basketball%20players%20celebrating%20victory%20on%20court%20in%20packed%20arena%20with%20dramatic%20lighting%20editorial%20sports%20photography%20high%20detail&width=1200&height=675&seq=news-nba-01&orientation=landscape",
    tags: ["NBA", "湖人", "凯尔特人"],
    featured: true,
  },
  {
    id: "nw-2002",
    title: "曼城 2:1 力克利物浦，英超榜首之争再起波澜",
    excerpt:
      "英超第 9 轮焦点战，曼城主场 2:1 击败利物浦，凭借一场关键胜利暂时登上积分榜首位。",
    content: [
      "本轮英超最受瞩目的比赛在伊蒂哈德球场打响，曼城与利物浦这对争冠老对手再度碰面。",
      "比赛开始后双方节奏极快，曼城通过边路传中率先打破僵局。利物浦随后加强中场逼抢，并在下半场通过一次快速反击扳平比分。",
      "就在人们以为比赛将以平局收场时，曼城在终场前利用一次定位球机会由中卫头球破门，最终以 2:1 拿下三分。",
      "本场过后，曼城暂时登上积分榜首位，而利物浦则被身后球队缩小了差距，争冠形势更加胶着。",
    ],
    category: "赛事新闻",
    author: "51每日大赛赛事组",
    date: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=football%20players%20celebrating%20goal%20in%20night%20stadium%20with%20green%20pitch%20and%20blurred%20crowd%20editorial%20sports%20photography&width=1200&height=675&seq=news-epl-01&orientation=landscape",
    tags: ["英超", "曼城", "利物浦"],
    featured: true,
  },
  {
    id: "nw-2003",
    title: "郑钦文直落两盘夺得中网女单冠军",
    excerpt:
      "中国金花郑钦文在决赛中表现出色，以 6:4、6:3 击败强敌，职业生涯首次捧起中网女单冠军奖杯。",
    content: [
      "国家网球中心钻石球场座无虚席，本土选手郑钦文在主场观众的助威声中迎来了中网女单决赛。",
      "面对世界顶尖对手，郑钦文在发球局中表现得极为稳定，一发得分率始终保持在高位，让对手难以找到破发机会。",
      "两盘比赛中，郑钦文多次在关键分上利用底线相持主动变线得分，最终以 6:4、6:3 直落两盘锁定胜局。",
      "赛后郑钦文表示，主场观众的支持给了她巨大的动力，这个冠军对她这个赛季的意义非常重大。",
    ],
    category: "选手动态",
    author: "51每日大赛赛事组",
    date: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=tennis%20player%20holding%20trophy%20on%20center%20court%20under%20night%20lights%20blurred%20crowd%20editorial%20sports%20photography&width=1200&height=675&seq=news-tennis-01&orientation=landscape",
    tags: ["网球", "中网", "郑钦文"],
    featured: true,
  },
  {
    id: "nw-2004",
    title: "F1 新加坡站前瞻：夜赛街道赛道考验车队策略",
    excerpt:
      "本周末 F1 将转战新加坡滨海湾街道赛道，夜赛与狭窄赛道的组合让策略选择变得尤为关键。",
    content: [
      "作为赛历中最具观赏性的分站之一，新加坡大奖赛以夜赛和街道赛道闻名。",
      "滨海湾赛道弯道密集、超车点有限，安全车出现的概率较高，这使得进站时机的选择成为决定胜负的重要因素。",
      "多支车队在本站带来了针对性的空气动力学升级，希望在慢速弯角获得更多下压力优势。",
      "排位赛表现预计将直接影响正赛结果，抢到前排位置的车手将掌握主动权。",
    ],
    category: "专题报道",
    author: "51每日大赛赛事组",
    date: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=formula%20one%20car%20racing%20through%20night%20city%20street%20circuit%20with%20glowing%20buildings%20and%20track%20lights%20editorial%20motorsport%20photography&width=1200&height=675&seq=news-f1-01&orientation=landscape",
    tags: ["F1", "新加坡", "夜赛"],
    featured: false,
  },
  {
    id: "nw-2005",
    title: "LOL 全球总决赛八强对阵出炉，中韩大战一触即发",
    excerpt:
      "随着小组赛结束，英雄联盟全球总决赛八强对阵正式确定，多场中韩对决成为最大看点。",
    content: [
      "经过两周的小组赛争夺，本届英雄联盟全球总决赛八强席位全部产生。",
      "抽签结果显示，多支中韩战队将在八强阶段提前相遇，这意味着淘汰赛阶段将上演高强度对抗。",
      "从小组赛的表现来看，各队对于当前版本的理解差异明显，BP 阶段的博弈将成为比赛的重要看点。",
      "八强赛将于本周陆续开打，赛程安排与直播信息可在本站赛程页面查看。",
    ],
    category: "赛事新闻",
    author: "51每日大赛赛事组",
    date: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=esports%20arena%20stage%20with%20large%20screens%20and%20colorful%20lights%20crowd%20silhouettes%20dark%20atmosphere%20editorial%20photography&width=1200&height=675&seq=news-lol-01&orientation=landscape",
    tags: ["电竞", "全球总决赛", "英雄联盟"],
    featured: false,
  },
  {
    id: "nw-2006",
    title: "中国女排鏖战五局战胜巴西，年轻球员表现亮眼",
    excerpt:
      "世界女排联赛分站赛中，中国女排与巴西女排鏖战五局，最终凭借关键分的稳定发挥笑到最后。",
    content: [
      "在天津体育馆进行的一场世界女排联赛分站赛中，中国女排迎来了强敌巴西队。",
      "比赛过程跌宕起伏，双方在前四局战成 2:2 平，胜负被拖入决胜局。",
      "决胜局中，中国女排的年轻球员在拦网和发球环节连续得分，帮助球队建立起领先优势并保持到终场。",
      "赛后教练组表示，年轻球员在高强度对抗中的成长是本场比赛最大的收获。",
    ],
    category: "战报速递",
    author: "51每日大赛赛事组",
    date: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=volleyball%20players%20celebrating%20point%20near%20net%20in%20bright%20indoor%20arena%20editorial%20sports%20photography&width=1200&height=675&seq=news-volley-01&orientation=landscape",
    tags: ["排球", "中国女排", "世界联赛"],
    featured: false,
  },
  {
    id: "nw-2007",
    title: "夏季转会窗口盘点：多支豪门完成阵容升级",
    excerpt:
      "转会窗口临近关闭，多支球队在最后阶段完成关键引援，为新赛季的争冠之路补强阵容。",
    content: [
      "随着转会窗口接近尾声，各支球队的引援工作进入冲刺阶段。",
      "多家豪门俱乐部在中前场完成了重要补强，希望通过引入即战力提升球队的进攻效率。",
      "与此同时，也有不少球队选择清理冗员，为年轻球员腾出更多的出场空间。",
      "从整体来看，本赛季的转会投入较往年有所上升，竞争激烈程度可见一斑。",
    ],
    category: "转会市场",
    author: "51每日大赛赛事组",
    date: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=football%20stadium%20empty%20green%20pitch%20with%20modern%20architecture%20and%20clear%20sky%20editorial%20photography&width=1200&height=675&seq=news-transfer-01&orientation=landscape",
    tags: ["转会", "足球", "豪门"],
    featured: false,
  },
  {
    id: "nw-2008",
    title: "ATP 上海大师赛：阿尔卡拉斯晋级，新老对决再引热议",
    excerpt:
      "ATP 上海大师赛男单半决赛，阿尔卡拉斯直落两盘击败德约科维奇，顺利晋级决赛。",
    content: [
      "旗忠森林体育城的中央球场迎来了本届上海大师赛最受关注的一场半决赛。",
      "年轻的阿尔卡拉斯在比赛中展现出极强的移动能力与底线进攻火力，多次通过正手制胜分赢得关键分。",
      "德约科维奇虽然经验丰富，但在多拍相持中逐渐落入下风，最终以 4:6、5:7 遗憾告负。",
      "赛后两人在网前友好致意，新老交替的话题再度成为球迷讨论的焦点。",
    ],
    category: "选手动态",
    author: "51每日大赛赛事组",
    date: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=tennis%20player%20celebrating%20match%20point%20on%20hard%20court%20with%20afternoon%20sunlight%20editorial%20sports%20photography&width=1200&height=675&seq=news-atp-01&orientation=landscape",
    tags: ["网球", "ATP", "大师赛"],
    featured: false,
  },
];